export const CLINIC_COLORS = {
  primary: "#00658D",
  primaryLight: "#00AEEF",
  ink: "#0c2d4a",
  body: "#181c20",
  muted: "#3e4850",
  subtle: "#6e7881",
  placeholder: "#94a3b8",
  divider: "#dfe3e8",
  ghost: "rgba(189,200,209,0.3)",
  surfaceHighest: "#f1f4f9",
  warmAmberBg: "rgba(141,79,0,0.08)",
  warmAmber: "#6d3a00",
};

export const BTN_GRADIENT = "linear-gradient(180deg, #00aeef 0%, #00658d 100%)";
export const CLINICAL_SHADOW = "0 4px 20px rgba(0,101,141,0.06)";
export const CLINICAL_CARD = {
  background: "#fff",
  borderRadius: "24px",
  boxShadow: CLINICAL_SHADOW,
  border: "1px solid rgba(189,200,209,0.15)",
};

export const THYROID_TESTS = [
  { key: "tsh", name: "TSH", unit: "mIU/L" },
  { key: "ft4", name: "fT4", unit: "pmol/L" },
  { key: "ft3", name: "fT3", unit: "pmol/L" },
  { key: "atpo", name: "aTPO", unit: "kU/L" },
  { key: "tsi", name: "TSI", unit: "IU/L" },
  { key: "tg", name: "TG", unit: "mcg/L" },
  { key: "atg", name: "aTG", unit: "kU/L" },
  { key: "calcitonin", name: "Kaltsitoniin", unit: "pmol/L" },
];

export const INFLAMMATION_TESTS = [
  { key: "leucocytes", name: "Leukotsüüdid", unit: "×10⁹/L" },
  { key: "crp", name: "CRP", unit: "mg/L" },
];

export const BLOOD_PANEL_TESTS = [
  { key: "neutrophiles", name: "Neutrofiilid", unit: "×10⁹/L" },
  { key: "lymphocytes", name: "Lümfotsüüdid", unit: "×10⁹/L" },
  { key: "monocytes", name: "Monotsüüdid", unit: "×10⁹/L" },
];

export const INITIAL_QUESTIONNAIRE = {
  age: "", gender: "", pregnant: "", pregnantWeeks: "",
  thyroidDiseasesBefore: "", graves: "", hashimoto: "",
  thyroidNodules: "", thyroidCancer: "",
  totalThyroidectomy: "", partialThyroidectomy: "",
  levothyroxin: "", levothyroxinDosage: "",
  levoBeforeBreakfast: "", levoRegularly: "",
  takesCalcium: "", takesIron: "", takesAcidReducer: "",
  levoTwoHoursApart: "",
  thiamazole: "", thiamazoleDosage: "",
  propylthiouracil: "", propylthiouracilDosage: "",
  cordarone: "", heartDisease: "",
  iodinatedSalt: "", iodineSkin: "", iodineSpray: "", ctContrast: "",
  hasFever: "", hasFatigue: "", hasNeckPain: "", symptomsAfterVirusInfection: "",
};

export const FIELD_LABELS_ET = {
  age: "Vanus", gender: "Sugu", pregnant: "Rasedus", pregnantWeeks: "Raseduse nädalad",
  thyroidDiseasesBefore: "Varem diagnoositud kilpnäärmehaigus",
  graves: "Gravesi tõbi", hashimoto: "Hashimoto türeoidiit",
  thyroidNodules: "Kilpnäärme sõlmed", thyroidCancer: "Kilpnäärmevähk",
  totalThyroidectomy: "Kilpnäärme täielik eemaldamine",
  partialThyroidectomy: "Kilpnäärme osaline eemaldamine",
  levothyroxin: "Levotüroksiin", levothyroxinDosage: "Levotüroksiini annus (µg)",
  levoBeforeBreakfast: "Võtab enne hommikusööki", levoRegularly: "Võtab regulaarselt",
  takesCalcium: "Kaltsiumi tarvitamine", takesIron: "Rauapreparaadid",
  takesAcidReducer: "Happesuse alandajad",
  levoTwoHoursApart: "≥2h vahe levotüroksiinist",
  thiamazole: "Tiamasool", thiamazoleDosage: "Tiamasooli annus (mg)",
  propylthiouracil: "Propüültiouratsiil", propylthiouracilDosage: "Propüültiouratsiili annus (mg)",
  cordarone: "Cordarone / Amiodaroon", heartDisease: "Südamehaigus",
  iodinatedSalt: "Jodeeritud sool", iodineSkin: "Nahaga joodi kokkupuude",
  iodineSpray: "Joodisprei", ctContrast: "CT kontrastaine",
  hasFever: "Palavik", hasFatigue: "Väsimus/nõrkus",
  hasNeckPain: "Kaelavalu", symptomsAfterVirusInfection: "Sümptomid pärast viirusinfektsiooni",
};

export const VALUE_LABELS_ET = { yes: "Jah", no: "Ei", male: "Mees", female: "Naine", other: "Muu" };
